export default __webpack_public_path__ + "static/3-77baa5dcb688e5ba4ab7bc860ab22a72.svg";